import type { Layout } from '../render/layout';
import { gridCellAt } from '../render/layout';
import { hitTestButton, hitTestVisibleButton } from '../render/buttons';
import type { ButtonId } from '../types';

export interface PointerHandlers {
  getLayout: () => Layout;
  onButton: (id: ButtonId) => void;
  onGridTap: (bar: number, varIdx: number) => void;
  onHoverChange: (id: ButtonId | null) => void;
}

export function installPointer(canvas: HTMLCanvasElement, h: PointerHandlers): () => void {
  function onDown(e: PointerEvent): void {
    const layout = h.getLayout();
    const x = e.clientX;
    const y = e.clientY;
    const btn = hitTestButton(x, y, layout);
    if (btn) {
      h.onButton(btn);
      return;
    }
    const cell = gridCellAt(x, y, layout);
    if (cell) h.onGridTap(cell.bar, cell.varIdx);
  }

  function onMove(e: PointerEvent): void {
    const layout = h.getLayout();
    const visible = hitTestVisibleButton(e.clientX, e.clientY, layout);
    h.onHoverChange(visible);
    canvas.style.cursor = visible || gridCellAt(e.clientX, e.clientY, layout) ? 'pointer' : 'default';
  }

  function onLeave(): void {
    h.onHoverChange(null);
    canvas.style.cursor = 'default';
  }

  canvas.addEventListener('pointerdown', onDown);
  canvas.addEventListener('pointermove', onMove);
  canvas.addEventListener('pointerleave', onLeave);
  return () => {
    canvas.removeEventListener('pointerdown', onDown);
    canvas.removeEventListener('pointermove', onMove);
    canvas.removeEventListener('pointerleave', onLeave);
  };
}
